import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import en_US from './langs/en_US'
import zh_CN from './langs/zh_CN'
import Element from '@jdpop/element-ui'
Vue.use(VueI18n)

// 这里我默认只将英文打包进去，其他语言都通过懒加载进行获取，将每个语言包进行单独拆包，避免将所有语言包打包进一个地区进行一次性全部加载，你也可以同时打包多个语言进去，具体看vue-i18n的文档
const messages = {
  zh_CN: zh_CN,
  // en_US: en_US
}

const i18n = new VueI18n({
  locale: 'zh_CN', // set locale
  messages, // set locale messages
})

window.i18n = i18n
Vue.use(Element)

export default i18n
